import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../../services/api.service';

export default function useClientDocumentTemplates() {
  const [isUploading, setIsUploading] = useState(false);
  const [archivingId, setArchivingId] = useState(null);

  /**
   * Dépose un template de document (BL, lettre de voiture, ...) pour un client.
   * @param {number} clientId - L'identifiant du client
   * @param {{ type: string, name: string, file: File }} template
   * @returns {Promise<object|null>} Le template créé, ou null en cas d'erreur
   */
  const uploadTemplate = async (clientId, { type, name, file }) => {
    try {
      setIsUploading(true);

      const formData = new FormData();
      formData.append('type', type);
      formData.append('name', name);
      formData.append('file', file);

      const response = await fleetApi.post(
        `/super-admin/clients/${clientId}/document-templates`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.status !== 200) {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }

      toast.success(`Template « ${name} » déposé.`);

      return response.data.document_template;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      return null;
    } finally {
      setIsUploading(false);
    }
  };

  /**
   * @returns {Promise<boolean>} true si le template a été supprimé
   */
  const archiveTemplate = async (clientId, templateId) => {
    try {
      setArchivingId(templateId);

      const response = await fleetApi.delete(
        `/super-admin/clients/${clientId}/document-templates/${templateId}`
      );

      if (response.status !== 200) {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }

      toast.success('Template supprimé.');

      return true;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      return false;
    } finally {
      setArchivingId(null);
    }
  };

  return {
    isUploading,
    archivingId,
    uploadTemplate,
    archiveTemplate,
  };
}
